import { Component, inject, signal } from '@angular/core'
import { TxNativeModule } from '@emilfreydigital/transifex-angular'
import { CptGoogleTagmanagerService } from '../../../services/cpt-google-tagmanager.service'
import { SharedService } from '../../../services/shared.service'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import type { CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { BrandComponent } from './brand/brand.component'
import { SocialComponent } from './social/social.component'
import { DividerComponent } from '../divider/divider.component'
import { LinksComponent } from './links/links.component'
import { ImpressumComponent } from './impressum/impressum.component'

@Component({
  standalone: true,
  selector: 'customer-portal-app-revolution-footer',
  templateUrl: './revolution-footer.component.html',
  imports: [
    BrandComponent,
    SocialComponent,
    DividerComponent,
    LinksComponent,
    ImpressumComponent,
    TxNativeModule
  ]
})
export class RevolutionFooterComponent {
  isMobilePwa

  private readonly remoteConfigService = inject(EfRemoteConfigurationService<CustomerPortalConfig>)

  readonly isUserCentricEnabled = signal<boolean>(this.remoteConfigService.get('analytics.usercentrics.enabled'))

  constructor(
    private readonly cptGtmService: CptGoogleTagmanagerService,
    private readonly sharedService: SharedService
  ) {
    this.isMobilePwa = this.sharedService.isMobilePwa()
  }

  sendGTMNavigationData(label?: string): void {
    this.cptGtmService.sendNavigationLinkData(null, 'Footer Navigation', label)
  }

  openPrivacySettings (): void {
    if (globalThis.UC_UI) {
      globalThis.UC_UI.showSecondLayer()
    }
  }
}
